/** @format */

import React from 'react';

const AdminDashboardPage: React.FC = () => {
	return <p className='text-2xl font-bold'>Admin Dashboard</p>;
};

export default AdminDashboardPage;
